module.exports = __webpack_public_path__ + "images/category_lp/car/store_images/2_9d40c904afd5e18d32f8a9e3dbf88981.png";